<template>
  <div class="link-talk">
    <div class="edit-box">
      <tpl-detail :titName="linkInfo.nodeTypeDesc">
        <template slot="body">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            maxlength="2000"
            placeholder="输入您的想法，最多2000字"
            show-word-limit
            v-model="form.content"
          ></el-input>
          <div class="tu-list clearfix">
            <uploader
              style="display: inline-block; width: 100%"
              list-type="text"
              :multiple="true"
              :limit="10"
              accept="*"
              :maxSize="30 * 1024 * 1024"
              :file-list.sync="form.fileList"
              @uploadFile="uploadFile"
            />
          </div>
          <div class="fs clearfix">
            <el-button
              :disabled="linkInfo.isOngoing == 1"
              :type="linkInfo.isOngoing == 1 ? 'info' : 'primary'"
              size="small"
              class="fr"
              @click="subContent"
              >发送</el-button
            >
          </div>
        </template>
      </tpl-detail>
    </div>
    <div class="liuyan-box">
      <div class="liuyan-box-top">
        <h5 class="clearfix" style="padding: 10px 25px">
          <span class="tit fl"
            >全部{{ linkInfo.nodeTypeDesc }} {{ talkList.length }}</span
          >
          <div class="fr right-box">
            <el-input
              class="input-length"
              size="small"
              placeholder="搜索教师姓名或评论内容"
              v-model="form.keyword"
              clearable
            >
              <el-button
                slot="append"
                type="primary"
                class="search-btn"
                size="small"
                @click="getTalkList"
                >搜索</el-button
              >
            </el-input>
          </div>
        </h5>
      </div>

      <div class="liuyan-box-content">
        <div class="liuyan-list" v-for="i in talkList" :key="i.id">
          <h2>
            <img :src="i.userLogo ? i.userLogo : teacherIcon" alt />
            {{ i.userName }}
            <el-button
              v-if="i.createBy == userInfo.userId"
              type="text"
              class="liuyan-del fr"
              @click="delContent(i)"
              >删除</el-button
            >
          </h2>
          <div class="liuyan-body">
            <div>
              <h3>{{ i.content }}</h3>
              <!-- <div class="tu-list clearfix">
								<div class="tu-box fl" v-for="is in i.attach" :key="is.attachUrl">
									<el-image style="height: 100px;margin-right: 10px;" fit="fill" :src="is.attachUrl"></el-image>
								</div>
							</div>-->
              <div class="file-list">
                <link-file :link-info="i"></link-file>
              </div>
              <div class="liuyan-do clearfix">
                <span class="fl">{{ i.createTime }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="评论"
                  placement="top-start"
                >
                  <span class="hf fr" @click="getHuifuList(i)">
                    <i class="el-icon-chat-dot-square"></i>
                    {{ i.replyCount }}
                  </span>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="i.isPraise ? '取消' : '点赞'"
                  placement="top-start"
                >
                  <span
                    @click="toPraise(i)"
                    class="zan fr"
                    :class="i.isPraise ? 'active-zan' : ''"
                  >
                    <i class="iconfont icon-zan1"></i>
                    {{ i.praiseCount || "0" }}
                  </span>
                </el-tooltip>
              </div>
              <div class="liuyan-talk" v-if="i.showHf">
                <div class="my-input clearfix">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    maxlength="2000"
                    placeholder="输入您的评论，最多2000字"
                    show-word-limit
                    v-model="i.huifuText"
                  ></el-input>
                  <el-button
                    :disabled="i.huifuText.length == 0"
                    class="fb-btn fr"
                    type="primary"
                    size="small"
                    @click="subHf(i)"
                    >发布</el-button
                  >
                </div>
                <ul>
                  <li v-for="(hi, j) in i.huifuList" :key="hi.id" class="mb-sm">
                    <img :src="hi.userLogo ? hi.userLogo : teacherIcon" />
                    <span>{{ hi.userName }}</span>
                    <span>{{ hi.createTime }}</span>
                    <el-button
                      type="text"
                      class="liuyan-del fr"
                      v-if="hi.createBy == userInfo.userId"
                      @click="delHf(hi, j, i.huifuList)"
                      >删除</el-button
                    >
                    <br />
                    <p>{{ hi.content }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除的对话框 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </div>
</template>
<script>
import uploader from "@/components/school/uploader.vue";
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import LinkFile from "./LinkFile.vue";
import PopupDel from "@/components/PopupDel.vue";
export default {
  components: {
    TplDetail,
    uploader,
    LinkFile,
    PopupDel,
  },
  props: {
    linkInfo: "",
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      listExpand: [],
      form: {
        content: "",
        fileList: [], //回显
        attach: "",
        actCode: "",
        nodeCode: "",
        classify: "speak",
        operatorId: "",
        keyword: "",
      },
      talkList: [],
      teacherIcon: require("@/assets/image/other/man_teacher.png"),
      delVisible: false,
      curCode: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getTalkList();
    },
    async getTalkList() {
      try {
        let { records } = await postJson("/node/getNodeTopicContentList", {
          actCode: sessionStorage.getItem("actCode"),
          nodeCode: this.linkInfo.nodeCode,
          classify: this.linkInfo.nodeType,
          pageNum: 1,
          pageSize: -1,
          keyword: this.form.keyword,
          operatorId: this.userInfo.userId,
          schoolCode: this.userInfo.schoolCode,
        });
        if (records) {
          this.talkList = records.map((i) => {
            i.attach = JSON.parse(i.attach);
            i.showHf = false;
            i.huifuText = "";
            i.huifuList = [];
            i.attaches = i.attach;
            i.nodeAttaches = i.attach;
            if (!i.praiseCount) {
              i.praiseCount = 0;
            }
            return i;
          });
        } else {
          this.talkList = [];
        }
      } catch (error) {
        this.talkList = [];
      }
    },
    uploadFile(info) {
      this.form.fileList = info;
    },
    async subContent() {
      if (this.form.content.length === 0) {
        this.$message.error("请输入");
        return;
      }
      this.form.attach = JSON.stringify(this.form.fileList);
      this.form.actCode = sessionStorage.getItem("actCode");
      this.form.nodeCode = this.linkInfo.nodeCode;
      this.form.operatorId = this.userInfo.userId;
      this.form.classify = this.linkInfo.nodeType;
      await postJson("/node/saveOrUpdateNodeTopicContent", this.form);
      this.form.content = "";
      this.form.attach = "";
      this.form.fileList = [];
      this.getTalkList("");
      this.$message.success("保存成功");
    },
    //保存或取消点赞信息
    toPraise(i) {
      postJson("/node/saveNodeTopicContentPraise", {
        actCode: sessionStorage.getItem("actCode"),
        nodeCode: this.linkInfo.nodeCode,
        cttCode: i.cttCode,
        operatorId: this.userInfo.userId,
      }).then((res) => {
        if (i.isPraise == 1) {
          i.isPraise = 0;
          i.praiseCount -= 1;
        } else {
          i.isPraise = 1;
          i.praiseCount += 1;
        }
      });
    },
    async subHf(i) {
      await postJson("/node/saveNodeTopicContentReply", {
       classify: this.linkInfo.nodeType,
        actCode: i.actCode,
        nodeCode: i.nodeCode,
        operatorId: this.userInfo.userId,
        attach: JSON.stringify([]),
        content: i.huifuText,
        cttCode: i.cttCode,
      });
      i.huifuText = "";
      i.showHf = false;
      this.getHuifuList(i);
    },
    getHuifuList(i) {
      i.showHf = !i.showHf;
      if (i.showHf) {
        if (!this.listExpand.some((s) => s == i.id)) {
          this.listExpand.push(i.id);
        }
        postJson("/node/getNodeTopicContentReplyList", {
          actCode: i.actCode,
          nodeCode: i.nodeCode,
          cttCode: i.cttCode,
          pageNum: 1,
          pageSize: -1,
        }).then((res) => {
          i.huifuList = res.records;
          i.showHf = true;
        });
      } else {
        let t = this.listExpand.findIndex((s) => s == id);
        if (t != -1) {
          this.listExpand.splice(t, 1);
        }
      }
    },
    async delContent(i) {
      this.delVisible = true;
      this.curCode = i;
    },
    delHf(i, j, list) {
      postData("/node/deleteNodeTopicContentReply", {
        cttCode: i.cttCode,
        nodeCode: i.nodeCode,
        createBy: i.createBy,
        id: i.id,
      })
        .then((res) => {
          list.splice(j, 1);
        })
        .catch((e) => {
          this.$message.fail("操作失败！");
        });
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        if (status) {
          await postData("/node/deleteNodeTopicContent", {
            cttCode: this.curCode.cttCode,
            nodeCode: this.curCode.nodeCode,
          });
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
            offset: 150,
          });
          this.delVisible = false;
          this.getTalkList();
        } else {
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
      this.delVisible = false;
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.link-talk {
  @font-face {
    font-family: "iconfont";
    /* Project id 2622609 */
    src: url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.woff2?t=1629870048673")
        format("woff2"),
      url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.woff?t=1629870048673")
        format("woff"),
      url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.ttf?t=1629870048673")
        format("truetype");
  }

  .icon-zan1:before {
    content: "\e600";
  }

  .edit-box {
    .tu-list {
      margin-top: 5px;
      padding: 5px;
      border: 1px solid #eee;

      .tu-box {
        margin-left: 10px;
        margin-bottom: 5px;
        margin-top: 5px;
        position: relative;
        left: 0px;
        top: 0px;

        .del-sc {
          position: absolute;
          right: 5px;
          top: 5px;
          border: 1px solid rgba(146, 145, 145, 0);
          z-index: 20;
          color: rgba(224, 213, 213, 0);
          font-size: 16px;
          background: none;
          padding: 5px;
        }
      }

      .tu-box:hover {
        .del-sc {
          color: @hong;
        }
      }
    }

    .file-list {
      margin-top: 5px;
      padding: 5px;
      border: 1px solid #eee;

      ul {
        padding-left: 8px;
        margin: 2px 0px;

        li {
          padding: 8px;
          margin-top: 8px;
          border: 1px solid rgb(224, 222, 222);
          border-radius: 5px;

          .big-icon {
            font-size: 35px;
            color: @color;
            font-weight: 700;
          }

          .divider {
            margin-left: 20px;
            // border: 0.3px solid rgb(226, 220, 220);
            height: 38px;
          }

          h1 {
            font-size: 13px;
            padding-left: 10px;
          }

          h2 {
            margin-top: 2px;
            font-size: 12px;
            padding-left: 10px;
            color: @hui;
          }

          .name-school {
            font-size: 13px;
            margin-top: 10px;
          }

          .look {
            margin-right: 60px;
          }

          .dow {
            margin-right: 100px;
          }

          .del {
            margin-right: 60px;
          }
        }
      }
    }

    .fs {
      margin-top: 10px;
    }
  }

  .liuyan-box {
    margin-top: 25px;
    // border: 1px solid #000;
    background: #fff;

    .liuyan-box-top {
      h5 {
        border-bottom: 3px solid #f7f7f7;
        padding: 5px 20px;

        .tit {
          font-size: 15px;
          font-weight: 700;
          color: @color;
          padding: 7px 5px;
        }

        .right-box {
          height: 35px;
          line-height: 35px;

          span {
            font-size: 13px;
            cursor: pointer;
            padding: 5px;
          }
        }
      }
    }

    .liuyan-box-content {
      padding: 10px 25px;
      background-color: #fff;

      .liuyan-list {
        border: 1px solid rgb(226, 220, 220);
        border-radius: 3px;
        margin-bottom: 18px;
        padding: 10px;

        h2 {
          font-size: 15px;

          img {
            border: 1px solid rgb(209, 204, 204);
            width: 40px;
            height: 40px;
            border-radius: 50%;
            vertical-align: middle;
            margin-right: 10px;
          }

          .liuyan-del {
            color: @hong;
            margin-right: 50px;
          }
        }

        .liuyan-body {
          padding: 0px 0px 00px 50px;

          h3 {
            margin-top: 6px;
            text-indent: 25px;
            font-size: 13.7px;
            color: rgb(56, 53, 53);
            font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS",
              sans-serif;
          }

          .tu-list {
            margin-top: 3px;
            padding: 5px;

            .tu-box {
              margin-bottom: 5px;
              margin-top: 5px;
            }
          }

          .file-list {
            padding: 0px;

            ul {
              padding-left: 5px;
              margin: 0px;

              li {
                padding: 8px;
                margin-bottom: 8px;
                border: 1px solid rgb(224, 222, 222);
                border-radius: 5px;

                .big-icon {
                  font-size: 35px;
                  color: @color;
                  font-weight: 700;
                }

                .divider {
                  margin-left: 20px;
                  height: 38px;
                }

                h1 {
                  font-size: 13px;
                  padding-left: 10px;
                }

                h2 {
                  margin-top: 2px;
                  font-size: 12px;
                  padding-left: 10px;
                  color: @hui;
                }

                .name-school {
                  font-size: 13px;
                  margin-top: 10px;
                }

                .look {
                  margin-right: 60px;
                }

                .dow {
                  margin-right: 100px;
                }
              }
            }
          }

          .liuyan-do {
            margin-top: 15px;

            span {
              color: @hui;
              font-size: 12.5px;
              vertical-align: middle;
            }

            .zan {
              cursor: pointer;
              margin-right: 40px;
              font-size: 13px;
            }

            .active-zan {
              color: @color;
            }

            .hf {
              cursor: pointer;
              margin-right: 40px;

              i {
                font-size: 19px;
              }
            }

            .hf:hover {
              color: @color;
            }

            .zan:hover {
              color: @color;
            }
          }

          .liuyan-talk {
            margin-top: 30px;

            .my-input {
              .fb-btn {
                margin-top: 10px;
              }
            }

            ul {
              padding-left: 0px;

              //   border: 1px solid rgb(34, 88, 206);
              li:nth-of-type(1) {
                border-top: 1px solid rgb(231, 231, 231);
              }

              li {
                border: 1px solid rgb(231, 231, 231);
                padding: 7px 20px;
                // margin-bottom: 10px;
                border-radius: 5px;

                img {
                  width: 33px;
                  height: 33px;
                  border-radius: 50%;
                  vertical-align: middle;
                  margin-right: 5px;
                  border: 1px solid #eee;
                }

                span {
                  //   border: 1px solid #000;
                  font-size: 14px;
                  margin: 0px 12px;
                }

                span:nth-of-type(2) {
                  font-size: 12px;
                  color: @hui;
                }

                p {
                  font-size: 13px;
                  text-indent: 28px;
                  padding-left: 35px;
                  //   border: 1px solid #000;
                  margin: 7px 0px;
                }

                .liuyan-del {
                  color: @hong;
                  margin-right: 80px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
